import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Schema } from '../models/schema.model';
import { Field } from '../models/field.model';
import { SchemaScript } from '../models/schema-script.model';
import { SchemaProperty } from '../models/schema-property.model';
import { Injectable } from '@angular/core';

@Injectable()
export class AppCreationService {

}
